import { useRollbar } from '@rollbar/react'
import { ErrorAlert, ThrownErrorBoundary } from '@xylabs/react-error'
import { FlexGrowCol } from '@xylabs/react-flexbox'
import { UserEventsProvider } from '@xylabs/react-pixel'
import { assertEx } from '@xylabs/sdk-js'
import React from 'react'
import { BrowserRouter } from 'react-router-dom'

import { XyoBasePage } from './common/XyoBasePage.tsx'
import { PixelProvider } from './contexts/index.ts'
import { getXyoUserEvents } from './hooks/index.ts'
import { LocalizedRootRoutes } from './modules/index.ts'

export const AppBody: React.FC = () => {
  const userEvents = getXyoUserEvents(import.meta.env.VITE_MIXPANEL_PUBLIC_PROJECT_TOKEN)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const windowAny = globalThis as any
  windowAny.rollbar = useRollbar()

  assertEx(userEvents, () => 'No user Events!!')

  return (
    <PixelProvider id="xyo.network">
      <UserEventsProvider userEvents={userEvents}>
        <BrowserRouter>
          <ThrownErrorBoundary
            boundaryName="Application"
            errorComponent={(error, boundaryName) => (
              <XyoBasePage>
                <ErrorAlert scope={boundaryName} error={error} />
              </XyoBasePage>
            )}
            rollbar={windowAny.rollbar}
          >
            <FlexGrowCol
              width="100vw"
              minHeight="100vh"
              justifyContent="flex-start"
              alignContent="stretch"
            >
              <LocalizedRootRoutes />
            </FlexGrowCol>
          </ThrownErrorBoundary>
        </BrowserRouter>
      </UserEventsProvider>
    </PixelProvider>
  )
}
